import AlertCardContainer from "../page/Alert/AlertCardContainer"
import { alertConfig } from "../../constants"
import AlertParameter from "../page/Alert/AlertParameter"

const DashboardAlert = ({ date, alerts }) => {
    if (
        alerts &&
        !alerts.momentumAlerts.length &&
        !alerts.preMarketAlerts.length &&
        !alerts.longtermMomentumAlerts?.length
    )
        return

    return (
        <section className='w-full m-auto flex'>
            <div className='flex-col justify-start gap-8 flex'>
                <div className='justify-start gap-2 flex flex-wrap flex-col'>
                    <div className='flex-col justify-start gap-2.5 flex'>
                        <div className='text-black text-xl font-bold'>
                            Today's Alert
                        </div>
                        <div className='text-black text-xs font-medium'>
                            {date} ET
                        </div>
                    </div>
                    <div className='gap-6 flex flex-wrap flex-col'>
                        <AlertCardContainer
                            alerts={alerts.preMarketAlerts}
                            index={0}
                        />
                        <AlertCardContainer
                            alerts={alerts.momentumAlerts}
                            index={1}
                        />
                        <AlertCardContainer
                            alerts={alerts.longtermMomentumAlerts || []}
                            index={2}
                        />
                    </div>
                </div>
                <div className='justify-start items-start gap-10 flex'>
                    {alertConfig.params.map((params, key) => {
                        return <AlertParameter key={key} {...params} />
                    })}
                </div>
            </div>
        </section>
    )
}

export default DashboardAlert
